(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("App2", ["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["App2"] = factory(require("react"), require("react-dom"));
	else
		root["App2"] = factory(root["React"], root["ReactDOM"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__639__, __WEBPACK_EXTERNAL_MODULE__346__) => {
return 